import {CableModel} from './cable.model';
import {LocationModel} from './location.model';

/**
 * Represents a single node in the location connection path
 */
export interface LocationPathNodeModel {
    location: LocationModel; // Location with all its related details included
    connectionId?: string; // ID of the connection leading to this node
    isExiNode: boolean; // True if this node is a leaf (EXI node)
    typeOfLocation: string;
    isGasAreaSafe?: boolean; // True if the area is classified as gas safe
    isDustAreaSafe?: boolean; // True if the area is classified as dust safe
    gasArea?: string; // Gas area classification details
    dustArea?: string; // Dust area classification details
    isLoopRulesResults?: {ruleKey: string; passed: boolean; errorMsg: string}[]; // Results of IS loop rules for this node
    cables?: CableModel[]; // Cables associated with this location node
}

/**
 * Represents a complete path from a distribution panel to a leaf node
 */
export interface LocationPathModel {
    pathId: string; // Unique identifier for this path
    depth: number; // Number of nodes in the path
    nodes: LocationPathNodeModel[]; // Ordered list from distribution panel to leaf
}

/**
 * Summary statistics for all paths from distribution panels
 */
export interface LocationPathSummaryModel {
    totalPaths: number;
    totalDistributionPanels: number;
    totalLeafNodes: number;
    averagePathDepth: number;
    maxPathDepth: number;
    minPathDepth: number;
    pathsByDistribution: {
        distributionPanelId: string;
        distributionPanelTitle: string;
        pathCount: number;
    }[];
}

/**
 * Complete result structure for location path analysis
 */
export interface LocationPathResultModel {
    paths: LocationPathModel[];
    summary: LocationPathSummaryModel;
}
